/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useAppCoffeeMugContext } from "../Components/AppCoffeeMugContext";
import { useAppSnackbar } from "../Components/AppSnackbarContext";
import { Code } from "../Components/AppSnackbarContext/AppSnackbarItem";
import { fixedT, translationKeys } from "../Internationalisierung/i18nBasis";

export type ZeigeAuthFehlerFunc = (istAktion: boolean, code?: Code) => void;

export default function useZeigeAuthFehler(): ZeigeAuthFehlerFunc {
    const appSnackbar = useAppSnackbar();
    const coffeeMug = useAppCoffeeMugContext();

    function zeigeAuthFehler(istAktion: boolean, code?: Code) {
        if (istAktion) {
            coffeeMug.hide();
            appSnackbar?.pushCustomError(
                "CloudApolloClientProvider",
                fixedT(translationKeys.cloudApolloClientProvider.keineRechte),
                code);
        } else {
            appSnackbar?.pushCustomError(
                "CloudApolloClientProvider",
                fixedT(translationKeys.cloudApolloClientProvider.unauthorized),
                code);
        }
    }

    return zeigeAuthFehler;
}
